import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import TextSection from '../../components/TextSection';
import ActionSection from '../../components/ActionSection';
import NevoBanner from '../../components/NevoBanner';

import styles from './styles.module.scss'
import EmobilityBackground from '../../public/assets/images/emobility-header.jpg';
import EmobilityImage from '../../public/assets/images/emobility-page-background.jpg'


export default function EMobilityEducationPage()  {
  return (
    <>
      <Head>
        <title>E-Mobility Education | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={EmobilityBackground.src} className={styles.homeChargingHeader}>
        <h1 className='page-header-h1'>E-Mobility Education.</h1>
      </PageHeader>

      <div className={`${styles.homeChargingPage} page-holder`}>
        <TextSection 
          header="We are passionate about electric mobility education."
          text={<>
            This can be a broad session to educate the full workforce on what is happening in the EV space, all the way down to a more focused workshop with drivers receiving their company electric vehicle. We are a team of experienced EV drivers and understand that driving an EV is different to a regular car or van.
            <br/><br/>
            Transitioning your fleet to electric requires several elements to be in place. Your business will require a detailed plan to successfully make the transition to electric mobility, from vehicle selection based on multiple driving habits and behaviours, charging advice, infrastructure, split charging billing and charging cards for employees.
            <br/><br/>
            We can design a workshop to educate and explain the best ways to charge an electric vehicle, all the way up to how to drive it as efficiently and effectively as possible.
          </>}
        />

        <div className={`${styles.emobilityImage} image-section section`} style={{ backgroundImage: `url(${EmobilityImage.src})` }}>&nbsp;</div>

        <ActionSection 
          header="Arrange an initial call"
          text="Interested in learning more about e-mobility? Contact us today to discover how our expert team can provide education and training to help your business transition to a more sustainable future."
          buttonText="Contact Us"
          href="/contact-us"
        />

        <NevoBanner />
      </div>

      <Footer />
    </>
  )
};
